/**
 * mSTEM Phase 6 / EXT-04 Publish Wizard mock package-contents list
 * (DR-04, MOCK-ONLY). Step-2 "Xác nhận nội dung gói" renders this as an
 * MstemTable so the Admin can confirm what the (mock) publish package
 * would contain. No real files are bundled — pure UI seed data; the
 * mock registry URL is generated client-side in 06-05.
 */
const EXT_PUBLISH_PACKAGE = [
    {id: 'manifest', name: 'manifest.json', sizeKB: 1},
    {id: 'blockdef', name: 'block-definitions.js', sizeKB: 4},
    {id: 'icon', name: 'icon.svg', sizeKB: 6},
    {id: 'meta', name: 'metadata.json', sizeKB: 1}
];

export default EXT_PUBLISH_PACKAGE;
